
<component
  :is="as"
  class="grade-variation-chip"
  :class="[gradeClass, { clickable, 'has-dropdown': dropdown, 'is-profile': profile, variation: Boolean(variation), 'no-color': noColor }]"
  v-bind="$attrs"
  v-on="$listeners"
  v-tooltip="dropdown && variation && { content: variation, delay: 300, placement: 'top' }"
>
  <span>{{ grade || variation }}</span>

  <icon
    v-if="dropdown"
    name="arrow_drop_down"
    class="icon"
  />
</component>
